<script setup>
import { CircleCheckIcon, CircleSlashIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";
import ProjectPreview from "./ProjectPreview.vue";

const projects = defineModel("projects");

defineProps({
    categories: {
        type: Array,
        default: [],
    },
    profiles: {
        type: Array,
        default: [],
    },
});

defineEmits(["deleteProject"]);

const { t: __ } = useI18n();
</script>
<template>
    <div class="bg-white rounded divide-y divide-gray-100 ring-1 ring-gray-300 dark:bg-gray-900 dark:divide-gray-800 dark:ring-gray-800">
        <div class="flex items-center px-3 py-2">
            <div :class="['text-sm font-medium', projects.length > 0 ? 'text-gray-900 dark:text-white' : 'text-gray-600 dark:text-gray-400']">
                {{ __("Projets") }}
            </div>
            <CircleCheckIcon v-if="projects.length > 0" class="size-4 ml-3 text-gray-900 dark:text-white" />
            <CircleSlashIcon v-else class="size-4 ml-3 text-gray-600 dark:text-gray-400" />
        </div>
        <div v-if="projects.length > 0" class="px-3 py-2 space-y-1">
            <template v-for="(project, index) in projects" :key="project.id">
                <ProjectPreview
                    v-model:project="projects[index]"
                    @deleteProject="$emit('deleteProject', index)"
                    :categories="categories"
                    :profiles="profiles" />
            </template>
        </div>
    </div>
</template>
